import React, { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { DEFAULT_MAP_CENTER } from '../../utils/routeUtils';

/**
 * MapBoundsFitter Component
 * Automatically fits map bounds to include all provided points ONLY on the initial render.
 * Never changes the user's view after the initial fit.
 * 
 * @param {Object} props - Component props
 * @param {Array} props.points - Array of points with lat/lng properties
 * @param {Array} [props.padding=[50,50]] - Padding to apply around bounds
 * @param {number} [props.maxZoom=null] - Maximum zoom level to use when fitting bounds
 */
const MapBoundsFitter = ({ points, padding = [50, 50], maxZoom = null }) => {
  const map = useMap();
  const initialFitDoneRef = useRef(false);
  
  useEffect(() => {
    // Only fit bounds on the very first render
    if (!initialFitDoneRef.current && points && points.length > 0) {
      try {
        const bounds = L.latLngBounds(points.map(point => [point.lat, point.lng]));
        const options = { padding };
        if (maxZoom !== null) {
          options.maxZoom = maxZoom;
        }
        map.fitBounds(bounds, options);
        
        // Mark that we've completed the initial fit
        initialFitDoneRef.current = true;
      } catch (error) {
        console.error('Error fitting bounds:', error);
        // Only set view on first render
        if (!initialFitDoneRef.current) {
          map.setView(DEFAULT_MAP_CENTER, 7);
          initialFitDoneRef.current = true;
        }
      }
    }
  }, [map, points, padding, maxZoom]);
  
  return null;
};

export default MapBoundsFitter; 